import on from 'dom-event'
import select from 'dom-select'
import { isOver, getSiblings } from 'utils/general'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default el => {
  function toggleBodyScroll (wrapper, container) {
    wrapper.classList.toggle('is-active')
    wrapper.classList.contains('is-active') ? disableBodyScroll(container) : enableBodyScroll(container)
  }

  on(document.body, 'click', (event) => {
    if (isOver(768)) {
      const filterButton = event.target.closest('.js-toggle-btn')

      if (filterButton) {
        select.all('.js-toggle-btn').forEach((btn) => {
          if (btn === filterButton) {
            filterButton.classList.toggle('is-active')
          } else {
            btn.classList.remove('is-active')
          }
        })
      } else if (!(filterButton)) {
        if (select('.js-toggle-btn.is-active')) {
          select('.js-toggle-btn.is-active').classList.remove('is-active')
        }
      }
    } else {
      const sorting = select('.js-filter')
      const filterOptions = select('.js-filter-options')
      const filterButton = event.target.closest('.js-toggle-btn')
      const filterLinks = select('.js-filter-options a')

      // Show button
      if (event.target.closest('.js-toggle-filter')) {
        event.preventDefault()
        toggleBodyScroll(sorting, filterOptions)
      }

      // Close button
      if (filterButton) {
        filterButton.classList.toggle('is-active')
      }

      // Filter option
      if (event.target.closest('.js-filter-options')) {
        event.preventDefault()
        event.target.parentNode.classList.toggle('is-selected')
      }

      // Apply filters button
      if (event.target.closest('.js-filter-btn-mobile')) {
        event.preventDefault()
        const url = window.location.href
        const tags = []
        let tagsPrefix = ''

        select.all('.js-filter-options a').forEach((option) => {
          const parent = option.parentNode

          if (parent.classList.contains('is-selected')) {
            const tagHandle = parent.getAttribute('data-tag-handle')
            tagsPrefix = '/tagged/'
            tags.push(tagHandle)
          }
        })

        window.location.href = url.split('/tagged')[0] + `${tagsPrefix}${tags.join('+')}`
      }
    }
  })
}
